var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-header":"","no-body":""}},[_c('div',{ref:_vm.divRef,class:`${_vm.divClass} overflow-auto`})])
}
var staticRenderFns = []

export { render, staticRenderFns }